import { FC } from 'react'
import { MapSquareIcon } from 'src/components/icons/map-square'
import { Colors } from 'src/components/theme'
import { Typography } from '@mui/material'
import styled from '@emotion/styled'
import { CircleIcon } from 'src/components/icons/circle-icon'

const Container = styled.div`
  background-color: ${Colors.neutral100};
  padding-right: 8px;
  border-radius: 40px;
  display: flex;
  gap: 4px;
  align-items: center;
`

type ParcelChipProps = {
  onClick?: () => void
  children: React.ReactNode
  maxWidth?: number
}

export const ParcelChip: FC<ParcelChipProps> = ({ onClick, children, maxWidth }) => {
  return (
    <Container onClick={onClick} style={{ cursor: !!onClick ? 'pointer' : 'auto', maxWidth }}>
      <CircleIcon size={22} color={Colors.primaryGreen700}>
        <MapSquareIcon size={8} />
      </CircleIcon>
      <Typography color={Colors.neutral700} fontSize={14} noWrap flex={1}>
        {children}
      </Typography>
    </Container>
  )
}
